import type { ReactElement } from "react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "src/common/state/hooks";
import WixarLogo3 from "../../common/components/Icon/WixarLogo3";
import SubscriptionIFrame, {
  isProAbonoOfferMessage,
} from "../../common/components/SubscriptionIFrame/SubscriptionIFrame";
import { jwtSelector } from "../../common/state/selectors/authSelector";
import {
  fetchSubscription,
  getSubscriptionStatus,
} from "../../features/subscription/state/subscriptionSlice";
import { logoutAuth } from "../../features/auth/state/authSlice";
import { Button } from "@mui/material";

export default function NoSubscriptionHome(): ReactElement {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const jwt = useAppSelector(jwtSelector);
  const subscriptionState = useAppSelector(getSubscriptionStatus);

  useEffect(() => {
    if (jwt) {
      void dispatch(fetchSubscription({}));
    }
  }, [jwt]);

  const msgCb = (event: MessageEvent) => {
    if (
      isProAbonoOfferMessage(event.data) &&
      event.data.ReferenceOffer &&
      event.data.IdSubscription
    ) {
      window.location.reload();
    }

    const frameProAbono = document.getElementById("frame-proabono");
    frameProAbono?.parentNode?.removeChild(frameProAbono);
  };

  const logout_click = () => {
    dispatch(logoutAuth());
  };

  return (
    <div className="flex flex-col grid h-full w-full bg-white">
      <div style={{ alignSelf: "end" }} className="flex justify-end mt-2 mr-2">
        <Button onClick={logout_click} className="btn-primary-fill">
          {t("general.logout")}
        </Button>
      </div>

      <div>
        <div
          className="grid items-center justify-center justify-items-center"
          style={{ paddingTop: "1%", paddingBottom: "1%" }}
        >
          <WixarLogo3 style={{ width: "75%" }} />
        </div>
      </div>

      <div>
        <div>
          <div className="text-center">
            <p>
              {subscriptionState === "NeverHasSubscription"
                ? t("pages.noSubscriptionHome.neverHasSubscriptionMessage")
                : t("pages.noSubscriptionHome.noSubscriptionMessage")}
            </p>
          </div>
        </div>
      </div>

      <div className="h-[70vh]">
        <SubscriptionIFrame msgCb={msgCb} />
      </div>
    </div>
  );
}
